module.exports = new __parcel__URL__("jsm-oncall.599266be.svg").toString();